import { castArray } from 'lodash-es'

import type { ChatActionInterface, ChatActionWithValue, ChatContent } from '../../models/chat'
import { ChatComposer } from './ChatComposer'

interface ChatFooterComposerProps {
  action?: ChatActionInterface
  sendMessage: (data: ChatActionWithValue | FormData) => void
  /** An answer is on its way to the server. */
  pending?: boolean
}

/** The composer pinned under the chat, shown only on steps answered in free text. */
export function ChatFooterComposer({ action, sendMessage, pending }: ChatFooterComposerProps) {
  const textarea = castArray<ChatContent | undefined>(action?.content).find(
    (item) => item?.component === 'TEXTAREA' && !item.props?.legacyFallback
  )
  if (!textarea) return null

  return (
    // Keyed so a new step starts from its own default rather than the last draft.
    <ChatComposer
      key={action?.key ?? action?.service}
      content={textarea}
      service={textarea.props?.service as string}
      handleSubmit={sendMessage}
      readonly={pending}
      pill
    />
  )
}
